import { Box, Typography, Link } from '@mui/material';

const CloudFooter = () => {
  return (
    <Box component="footer" sx={{ mt: 6, py: 4, textAlign: 'center', bgcolor: '#f8f9fb' }}>
      <Typography variant="body2">© {new Date().getFullYear()} CLOUD WiFi</Typography>
      <Box sx={{ mt: 1 }}>
        <Link href="/w/privacy_policy/">プライバシー</Link>
        {' ・ '}
        <Link href="/w/terms_of_service/">利用規約</Link>
      </Box>
    </Box>
  );
};

export default CloudFooter;
